import React, { useEffect } from "react";
import { BiRefresh } from "react-icons/bi";
import Input from "../Input/Input";
import "./TokenGenerator.css";

const TokenGenerator = (props) => {
	const generateNewToken = (props) => {
		// const randomToken = Math.random().toString(36).slice(2, 14);
		const randomToken = crypto.randomUUID();
		props.handleNewToken(randomToken);
		//navigator.clipboard.writeText(randomToken);
	};

	useEffect(() => {
		if (props.value === "") generateNewToken(props);
	}, [props]);

	return (
		<div className="token-generator-container relative">
			<Input
				name={props.name}
				id={props.id}
				className="input-token-generator pr-[46px]!"
				disabled={true}
				labelText="Código de acesso"
				value={props.value || ""}
				required={false}
				style={{ width: "100%" }}
				error={props.errors}
			/>
			{!props.disabled && (
				<button
					type="button"
					className="absolute right-2.5 top-1/2 -translate-y-1/2 cursor-pointer mt-2.5! hover:opacity-60 duration-150 rounded-(--borderRadius)!"
					onClick={() => generateNewToken(props)}
				>
					<BiRefresh
						size={25}
						color="#0C86C6"
					/>
				</button>
			)}
		</div>
	);
};

export default TokenGenerator;
